import { ArrowDownIcon } from 'ui-components/dist/ArrowDownIcon';
import { ArrowUpIcon } from 'ui-components/dist/ArrowUpIcon';
import { PlatformInstagramColorIcon } from 'ui-components/dist/PlatformInstagramColorIcon';
import { PlatformSnapchatColorIcon } from 'ui-components/dist/PlatformSnapchatColorIcon';
import { PlatformTikTokColorIcon } from 'ui-components/dist/PlatformTikTokColorIcon';
import { PlatformYouTubeColorIcon } from 'ui-components/dist/PlatformYouTubeColorIcon';

export const sortOptions = [
  {
    friendlyValue: 'Name (A to Z)',
    value: 'name:asc',
    icon: ArrowUpIcon,
    trackId: 'foam-myagency-stack-sortby-name:asc',
  },
  {
    friendlyValue: 'Name (Z to A)',
    value: 'name:desc',
    icon: ArrowDownIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-name:desc',
  },

  {
    friendlyValue: 'Age (High to Low)',
    value: 'age:desc',
    icon: ArrowUpIcon,
    trackId: 'foam-myagency-stack-sortby-age:desc',
  },
  {
    friendlyValue: 'Age (Low to High)',
    value: 'age:asc',
    icon: ArrowDownIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-age:asc',
  },
  {
    friendlyValue: 'Location (A to Z)',
    value: 'location:asc',
    icon: ArrowUpIcon,
    trackId: 'foam-myagency-stack-sortby-location:asc',
  },
  {
    friendlyValue: 'Location (Z to A)',
    value: 'location:desc',
    icon: ArrowDownIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-location:desc',
  },
  {
    friendlyValue: 'Instagram Audience (High to Low)',
    value: 'ig.followers:desc',
    icon: PlatformInstagramColorIcon,
    divider: false,
    trackId: 'foam-myagency-stack-sortby-ig-audience',
  },
  {
    friendlyValue: 'Instagram Audience (Low to High)',
    value: 'ig.followers:asc',
    icon: PlatformInstagramColorIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-ig-audience:asc',
  },
  {
    friendlyValue: 'Snapchat Audience (High to Low)',
    value: 'sc.followers:desc',
    icon: PlatformSnapchatColorIcon,
    divider: false,
    trackId: 'foam-myagency-stack-sortby-sc-audience',
  },
  {
    friendlyValue: 'Snapchat Audience (Low to High)',
    value: 'sc.followers:asc',
    icon: PlatformSnapchatColorIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-sc-audience:asc',
  },
  {
    friendlyValue: 'TikTok Audience (High to Low)',
    value: 'tt.followers:desc',
    icon: PlatformTikTokColorIcon,
    divider: false,
    trackId: 'foam-myagency-stack-sortby-tt-audience',
  },
  {
    friendlyValue: 'TikTok Audience (Low to High)',
    value: 'tt.followers:asc',
    icon: PlatformTikTokColorIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-tt-audience:asc',
  },
  {
    friendlyValue: 'YouTube Audience (High to Low)',
    value: 'yt.followers:desc',
    icon: PlatformYouTubeColorIcon,
    divider: false,
    trackId: 'foam-myagency-stack-sortby-yt-audience',
  },
  {
    friendlyValue: 'YouTube Audience (Low to High)',
    value: 'yt.followers:asc',
    icon: PlatformYouTubeColorIcon,
    divider: false,
    trackId: 'foam-myagency-stack-sortby-yt-audience:asc',
  },
];

export const sortSearchApiOptions = [
  {
    friendlyValue: 'Name (A to Z)',
    value: 'full_name:asc',
    icon: ArrowUpIcon,
    trackId: 'foam-myagency-stack-sortby-name:asc',
  },
  {
    friendlyValue: 'Name (Z to A)',
    value: 'full_name:desc',
    icon: ArrowDownIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-name:desc',
  },
  {
    friendlyValue: 'Age (High to Low)',
    value: 'date_of_birth:asc',
    icon: ArrowUpIcon,
    trackId: 'foam-myagency-stack-sortby-age:desc',
  },
  {
    friendlyValue: 'Age (Low to High)',
    value: 'date_of_birth:desc',
    icon: ArrowDownIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-age:asc',
  },
  {
    friendlyValue: 'Instagram Audience (High to Low)',
    value: 'platforms.instagram.followers_count:desc',
    icon: PlatformInstagramColorIcon,
    divider: false,
    trackId: 'foam-myagency-stack-sortby-ig-audience',
  },
  {
    friendlyValue: 'Instagram Audience (Low to High)',
    value: 'platforms.instagram.followers_count:asc',
    icon: PlatformInstagramColorIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-ig-audience:asc',
  },
  {
    friendlyValue: 'Snapchat Audience (High to Low)',
    value: 'platforms.snapchat.followers_count:desc',
    icon: PlatformSnapchatColorIcon,
    divider: false,
    trackId: 'foam-myagency-stack-sortby-sc-audience',
  },
  {
    friendlyValue: 'Snapchat Audience (Low to High)',
    value: 'platforms.snapchat.followers_count:asc',
    icon: PlatformSnapchatColorIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-sc-audience:asc',
  },
  {
    friendlyValue: 'TikTok Audience (High to Low)',
    value: 'platforms.tiktok.followers_count:desc',
    icon: PlatformTikTokColorIcon,
    divider: false,
    trackId: 'foam-myagency-stack-sortby-tt-audience',
  },
  {
    friendlyValue: 'TikTok Audience (Low to High)',
    value: 'platforms.tiktok.followers_count:asc',
    icon: PlatformTikTokColorIcon,
    divider: true,
    trackId: 'foam-myagency-stack-sortby-tt-audience:asc',
  },
  {
    friendlyValue: 'YouTube Audience (High to Low)',
    value: 'platforms.youtube.followers_count:desc',
    icon: PlatformYouTubeColorIcon,
    divider: false,
    trackId: 'foam-myagency-stack-sortby-yt-audience',
  },
  {
    friendlyValue: 'YouTube Audience (Low to High)',
    value: 'platforms.youtube.followers_count:asc',
    icon: PlatformYouTubeColorIcon,
    divider: false,
    trackId: 'foam-myagency-stack-sortby-yt-audience:asc',
  },
];
